import { useRef, useMemo } from 'react';
import { useElementSize, useLoadedImage, NoSSR, PostloadedImage } from '@utils/react';
import { OnImageFractionInput } from './input.fraction.js';
import { OnImageReadonlyInput } from './input.readonly.js';
import { OnImageTextInput } from './input.text.js';
import { backgroundImageMaxHeightInPx, canvas, inputs, background } from './organism.canvas.style.js';
import { transformInputsToRelativePositions } from './util.transform-to-relative-positions.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Canvas(props) {
  const imageRef = useRef(null);
  const dimensions = useElementSize(imageRef, {
    axis: "vertical",
    updateState: true,
    applyTo: imageRef
  });
  const img = useLoadedImage({
    src: props.task.backgroundImageSrc
  });
  const inputs$1 = useMemo(() => transformInputsToRelativePositions(props.task.content, img), [img, props.task.content]);
  const renderedImageHeight = dimensions.height ?? backgroundImageMaxHeightInPx;
  const inputScale = (img ? renderedImageHeight / img.naturalHeight : 1) * props.task.settings.scaleFactor;
  return /*#__PURE__*/jsxs("div", {
    className: canvas,
    children: [/*#__PURE__*/jsx(NoSSR, {
      children: /*#__PURE__*/jsx("div", {
        className: inputs,
        children: inputs$1?.map(input => {
          switch (input.nodeType) {
            case "on-image-text-input":
              return /*#__PURE__*/jsx(OnImageTextInput, {
                taskEntryKey: props.taskEntryKey,
                input: input,
                scale: inputScale,
                facitType: props.facitType
              }, input.id);
            case "on-image-fraction-input":
              return /*#__PURE__*/jsx(OnImageFractionInput, {
                taskEntryKey: props.taskEntryKey,
                input: input,
                scale: inputScale,
                facitType: props.facitType
              }, input.id);
            case "on-image-readonly":
              return /*#__PURE__*/jsx(OnImageReadonlyInput, {
                input: input,
                scale: inputScale
              }, input.id);
          }
        })
      })
    }), /*#__PURE__*/jsx(PostloadedImage, {
      ref: imageRef,
      className: background,
      src: props.task.backgroundImageSrc,
      alt: ""
    })]
  });
}

export { Canvas };
//# sourceMappingURL=organism.canvas.js.map
